import { CadenceKey } from "./guidanceCadence";
import { GuidancePersona } from "./guidancePersona";

export interface GuidanceDrawerOpenOptions {
  persona?: GuidancePersona;
  cadenceKey?: CadenceKey;
}

type Listener = (opts?: GuidanceDrawerOpenOptions) => void;

/**
 * `GuideDrawer` is a singleton mounted once in `RoleBasedLayout` (see
 * design-note.md §5) — it isn't reachable as a prop/context from arbitrary
 * pages without threading a provider through every role layout. This is a
 * minimal pub-sub so any page (the Playbook Hub's Drawer-mode cards, the
 * daily modal's "Let's Go") can open the one real drawer/float instance
 * instead of each building its own copy.
 */
let openDrawerListener: Listener | null = null;
let openFloatListener: Listener | null = null;

export const registerGuidanceDrawer = (
  onOpenDrawer: Listener,
  onOpenFloat: Listener
): (() => void) => {
  openDrawerListener = onOpenDrawer;
  openFloatListener = onOpenFloat;
  return () => {
    openDrawerListener = null;
    openFloatListener = null;
  };
};

export const openGuidanceDrawer = (opts?: GuidanceDrawerOpenOptions): void => {
  openDrawerListener?.(opts);
};

export const openGuidanceFloat = (opts?: GuidanceDrawerOpenOptions): void => {
  openFloatListener?.(opts);
};
